<template>
    <router-link tag="li" 
        class="inbox-entry d-flex align-items-center justify-content-between p-2 pl-3 m-0" 
        :to="{name: 'receivedfilesfolder', params: {folderId: entry.id}}" 
        @mouseover.native="badgeHover = true" 
        @mouseleave.native="badgeHover = false">
        <div class="d-flex align-items-center">
            <font-awesome-icon :icon="['fad', entry.icon]" class="mr-2" fixed-width />
            {{entry.name}}
        </div>
        <div class="badge-container d-flex align-items-center justify-content-center flex-shrink-0">
            <transition name="fade">
                <span v-if="!badgeHover && !isActiveRoute" class="badge badge-pill badge-primary">{{entry.count}}</span>
                <span v-if="badgeHover && !isActiveRoute" class="badge badge-pill badge-success">{{entry.unreadCount}} NEW</span>
                <font-awesome-icon v-if="isActiveRoute" :icon="['fad', 'angle-double-right']" fixed-width class="text-success"></font-awesome-icon>
            </transition>
        </div>
    </router-link>
</template>
<script>
export default {
    props: {
        entry: Object
    },
    data() {
        return {
            badgeHover: false
        }
    },
    computed: {
        isActiveRoute() {
            return this.$route.params.folderId >= 0 ? parseInt(this.$route.params.folderId) === this.entry.id : false;
        }
    }
}
</script>
<style scoped>
.inbox-entry {
    cursor: pointer;
    font-size: 0.9em;
}
.inbox-entry:hover {
    background: rgba(0,0,0,0.1);
}
.inbox-entry.router-link-exact-active {
    background: rgba(0,0,0,0.05);
}
.badge-container {
    min-width: 2.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/received-files-view/received-files-sidebar-entry.vue